// Service worker deliberately disabled.
//
// We hit iOS caching issues where Safari held onto stale app-shell bundles
// across deploys, so we no longer register one. `register()` is now a
// proactive un-installer: if a returning user still has the old SW from a
// previous deploy, this call kills it and clears its caches so the next
// load gets fresh assets.

export function register() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return

  navigator.serviceWorker.getRegistrations()
    .then(regs => regs.forEach(reg => reg.unregister()))
    .catch(() => {})

  if (typeof caches !== 'undefined' && caches.keys) {
    caches.keys()
      .then(keys => Promise.all(keys.map(k => caches.delete(k))))
      .catch(() => {})
  }
}

export function unregister() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return
  navigator.serviceWorker.getRegistrations()
    .then(regs => regs.forEach(reg => reg.unregister()))
    .catch(err => console.error(err.message))
}
